import { HandleInteractionKind, HandleType, Intent, MultiSlider } from "@blueprintjs/core"
import Scalar from "src/libs/scalars/scalars/Scalar"
import { ICompositeWidgetProps } from "../LandingCompositeWidget"
import { useEffect, useState } from "react"

/* Protopia Ecosystem component */ 
export interface IProportionScalarProps extends ICompositeWidgetProps {
    columns: number
}
const ProportionScalar = (props: IProportionScalarProps): JSX.Element => {
    return <>
        <Scalar 
            title={props.title}
            value={props.value}
            editable={props.editable}
            notClear
            enabledForm={<ProportionEnabled {...props}  columns={props.columns} />}  
            desabledForm={<ProportionDisable {...props} columns={props.columns} />}  
            subMenus={props.subMenus}
            onSubMenu={props.onSubmenu} 
        />
    </>
}

export const ProportionEnabled = (props: IProportionScalarProps): JSX.Element => {
    const getDefaultProportia = () => {
        return ((columns: number) => {
            const d = Math.floor(100 / columns)
            return Array( columns ).fill(0).map( f => d )
        })( props.columns || 1 )
    }
    const [value, setValue] = useState<number[]>( props.value || props.default || getDefaultProportia() )
    
    useEffect(() => {
        // setValue( props.value )
    }, [ props.value ])

    const getProportia = () => {
        return Array.isArray(value)
            ?
            value
            :
            getDefaultProportia()
    }
    const getHandlerValue = (n :number) : number => {
        const val = getProportia()
        return val.reduce((a, v, i) => {
            return i <= n ? a + v : a
        }, 0)
    }
    const setHandleValues = ( values: number[] ): number[] => {
        let vals: number[] = []
        let n: number = 0
        values.forEach(v => {
            if(v > 0 && v < 101) {
                n = v - n
                vals.push(n)
            }
        })
        return vals
    }
    const handleChange = ( rawValues: number[] ) => {
        const val = setHandleValues( rawValues ) 
        // console.log( "handleChange:", rawValues, val )
        setValue( val )
    }
    const handleRelease = ( rawValues: number[] ) => {
        const val = setHandleValues( rawValues )
        setValue( val, )
        // console.log( "handleRelease:", rawValues, val )
        if(props.onChange) {
            props.onChange( val, props.field, "" )
        }
    } 
    
    return <MultiSlider
                defaultTrackIntent={Intent.SUCCESS}
                labelStepSize={20}
                className="landing-proportia-3"
                max={100}
                min={0}
                onChange={handleChange}
                onRelease={handleRelease}
                showTrackFill
                stepSize={2}
                vertical={false}
            >
                <MultiSlider.Handle 
                        interactionKind={ HandleInteractionKind.PUSH }
                        type={ HandleType.START }
                        value={ 0 }
                    />
                {
                    getProportia().map((p, i) => {
                        return <MultiSlider.Handle
                            key={p}
                            interactionKind={ HandleInteractionKind.PUSH }
                            type={ i === ( props.columns || 1 ) - 1 ?  HandleType.END : HandleType.FULL }
                            value={  i === ( props.columns || 1 ) - 1 ? 100 : getHandlerValue( i ) }
                            disabled={ i === ( props.columns || 1 ) - 1 } 
                        />
                    })
                }
            </MultiSlider>
}

const ProportionDisable = (props: IProportionScalarProps): JSX.Element => {
    const [value, setValue] = useState<number[]>(props.value || props.default || [0, 100])
    return <>
    { 
        Array.isArray(value)
            ?
            value.join(" ") 
            :
            ((columns: number) => {
                const d = Math.floor(100 / columns)
                return Array(d).fill(0).map( f => d )
            })( props.columns | 1 )
                .join(" ") 
    }
    </>
}

export default ProportionScalar